module.exports = __webpack_public_path__ + "images/4835001a23b999c5022051417ebd47b7.jpg";


//////////////////
// WEBPACK FOOTER
// ./webpack/assets/img/thesuperlatives-story00.jpg
// module id = ./webpack/assets/img/thesuperlatives-story00.jpg
// module chunks = 0